import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fraction' })
export class FractionPipe implements PipeTransform {
    transform(numerator: number, denominator: number): string {
        return `${numerator}/${denominator}`;
    }
}
